var _defs, _style, _use, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    width: 600,
    height: 600,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    width: 600,
    height: 600,
    id: "img1",
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAlgAAAJYAQMAAACEqAqfAAAAAXNSR0IB2cksfwAAAANQTFRF////p8QbyAAAALZJREFUeJztzDENAAAMA6DVv+mZaNIHBJDricvlcrlcLpfL5XK5XC6Xy+VyuVwul8vlcrlcLpfL5XK5XC6Xy+VyuVwul8vlcrlcLpfL5XK5XC6Xy+VyuVwul8vlcrlcLpfL5XK5XC6Xy+VyuVwul8vlcrlcLpfL5XK5XC6Xy+VyuVwul8vlcrlcLpfL5XK5XC6Xy+VyuVwul8vlcrlcLpfL5XK5XC6Xy+VyuVwul8vlcrlcLtfgetTvAlmxc1e2AAAAAElFTkSuQmCC"
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", null)), _use || (_use = /*#__PURE__*/React.createElement("use", {
    href: "#img1",
    x: 0,
    y: 0
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m478.6 393.8v62.5c0 17.2-16 31.2-35.7 31.2h-285.8c-19.7 0-35.7-14-35.7-31.2v-62.5c0-17.3-15.9-31.3-35.7-31.3-19.7 0-35.7 14-35.7 31.3v62.5c0 51.7 48 93.7 107.1 93.7h285.8c59.1 0 107.1-42 107.1-93.7v-62.5c0-17.3-16-31.3-35.7-31.3-19.8 0-35.7 14-35.7 31.3zm-203.8-9.2c13.9 12.2 36.6 12.2 50.5 0l142.9-125c13.9-12.2 13.9-32.1 0-44.3-14-12.2-36.6-12.2-50.6 0l-81.9 71.7v-205.7c0-17.3-15.9-31.3-35.7-31.3-19.8 0-35.7 14-35.7 31.3v205.7l-81.9-71.7c-14-12.2-36.6-12.2-50.6 0-13.9 12.2-13.9 32.1 0 44.3 0 0 142.9 125 143 125z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/Download.66799d5dd82618ce930f2abbea61ce5f.svg";
export { ForwardRef as ReactComponent };